<!-- Title -->
@if (data.titleText) {
  <div
    class="title"
    >
    {{ data.titleText }}
  </div>
}

<!-- Description -->
@if (data.descriptionText) {
  <div
    class="description"
    >
    {{ data.descriptionText }}
  </div>
}

<!-- Actions -->
<div class="actions">
  <button
    class="app-button-gray"
    (click)="onCancelButtonClick()"
    >
    {{ data.cancelButtonText }}
  </button>

  <button
    class="app-button"
    (click)="onConfirmButtonClick()"
    >
    {{ data.confirmButtonText }}
  </button>
</div>